const {Get} = require('../lib/ajax')
const Embed = require('../embed/embed')

class Poll {
  constructor(url) {
    this.url = url
    this.interval = 5000

    this.element = document.querySelector('.js-upload-process')
    this.status = document.querySelector('.js-process-status')
    this.progress = document.querySelector('.js-process-progress')

    this.upload = document.querySelector('.js-upload')
    this.complete = document.querySelector('.js-upload-processed')
    this.processedTitle = document.querySelector('.js-processed-title')

    this.showElement()
    this.poll()
  }

  showElement() {
    document.body.classList.add('is-processing')
    if (this.element) this.element.classList.add('d-flex')
    if (this.element) this.element.classList.remove('d-none')
  }

  poll() {
    setTimeout(this.check.bind(this), this.interval)
  }

  check() {
    const request = new Get(this.url, {
      success: this.onProgress.bind(this)
    })
  }

  onProgress(data) {
    switch (data.state) {
      case 'pending':
      case 'processing':
        this.updateProgress(data)
        this.poll()
        break
      default:
        this.finalize(data)
    }
  }

  updateProgress(data) {
    this.updateSlidePreviews(data)
    if (this.status) this.status.innerText = data.title
    if (data.total > 0 && this.progress) this.progress.style.width = `${data.percent_complete}%`
  }

  finalize(data) {
    this.updateSlidePreviews(data)
    if (this.processedTitle) this.processedTitle.innerText = data.title
    if (this.upload) this.upload.classList.add('d-none')
    if (this.complete) this.complete.classList.remove('d-none')

    const embed = document.querySelector('.js-deck-embed')
    if (embed) {
      embed.outerHTML = data.embed_html
      Embed.init()
    }
  }

  updateSlidePreviews(data) {
    const slidePreviews = document.querySelector('.js-slide-previews')
    if (slidePreviews) slidePreviews.outerHTML = data.slides_html
  }
}

module.exports = Poll
